export default "__VITE_ASSET__DaYbruu0__"